module.exports = __webpack_public_path__ + "static/media/example-1.b295ce17.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/VanMasters/example-1.jpg
// module id = 257
// module chunks = 0